export const isProduction = process.env.NODE_ENV === "production";
export const isDemo = process.env.GATSBY_STAGING === "true";
export const isBuildLocal = process.env.GATSBY_BUILD_LOCAL === "true";
export const isReporting = true;
export const isDevelopment = isBuildLocal || !isProduction && !isDemo;

const BACKEND_URLS = {
  PROD: "https://adminapi.cmasa.org.au",
  DEMO: "https://test-adminapi.cmasa.org.au",
  REPORTING: "https://cmasa-reporting-api.tysnxu.qzz.io",
  YUWEN: "http://192.168.15.251:5001",
  YUWEN_JUNE_WIFI: "http://10.116.207.161:5001",
  OFFICE_SERVER: "http://192.168.15.252:5001",
  LOCALHOST: "http://localhost:5001",
  LAPTOP: "http://10.0.0.2:5001",
};

export const backEndBaseURL = (
  isReporting ? BACKEND_URLS.REPORTING
    : isBuildLocal ? BACKEND_URLS.LOCALHOST
      : isDemo ? BACKEND_URLS.DEMO
        : isProduction ? BACKEND_URLS.PROD
          : BACKEND_URLS.LAPTOP   // ONLY CHANGE THIS FOR DEVELOPMENT
);

const PUBLIC_FRONTEND_URLS = {
  PROD: "https://cmasa.org.au",
  STAGING: "https://test-public.cmasa.org.au",
  LOCALHOST: "http://localhost:8000",
};

export const publicFrontendBaseURL = (
  isReporting ? PUBLIC_FRONTEND_URLS.STAGING
    : isBuildLocal ? PUBLIC_FRONTEND_URLS.LOCALHOST
      : isDemo ? PUBLIC_FRONTEND_URLS.STAGING
        : isProduction ? PUBLIC_FRONTEND_URLS.PROD
          : PUBLIC_FRONTEND_URLS.LOCALHOST   // ONLY CHANGE THIS FOR DEVELOPMENT
);

export const isStagingUrl = backEndBaseURL === BACKEND_URLS.DEMO;
export const isDevUrl = [BACKEND_URLS.LOCALHOST, BACKEND_URLS.OFFICE_SERVER, BACKEND_URLS.YUWEN].includes(backEndBaseURL);
export const isProdUrl = backEndBaseURL === BACKEND_URLS.PROD;
export const isReportingUrl = backEndBaseURL.includes("reporting");

export const publicSiteBaseURL = (
  isBuildLocal ? PUBLIC_FRONTEND_URLS.LOCALHOST
    : isDemo ? PUBLIC_FRONTEND_URLS.STAGING
      : isProduction ? PUBLIC_FRONTEND_URLS.PROD
        : PUBLIC_FRONTEND_URLS.LOCALHOST   // ONLY CHANGE THIS FOR DEVELOPMENT
);

export const encryptedPassword = "*ENCRYPTEDPASSWORD*";

export const version = "0.1.14";  // DO NOT CHANGE THE VARIABLE NAME, GITHUB ACTION CHANGES THIS AUTOMATICALLY
export const LATEST_MUST_RELOGIN_VERSION = "0.1.14";

export const LOGGING_ENDPOINT_URL = "https://error-logging-worker.tysn-xu.workers.dev/api/error-logs";
export const ERROR_ENDPOINT_TOKEN = "xROtjE4cxKP7TBTfOkWFt8DpCysqYz4w";

export const SHOW_PAYMENT_PRICE_CHANGE_HISTORY = true;
export const SHOW_CLOSE_MEMBER_CLINICS = true;
export const ALLOW_DOWNLOAD_CLINIC_INFORMATION = true;
export const SHOW_ITEM_CHANGE_HISTORY = true;
export const SHOW_CPD_PACKAGE = true;
export const REMOVE_CPD_ADD_ON = true;
// export const SHOW_CPD_QUIZ = true;
export const SHOW_CPD_PROVIDER_SETTINGS = true;
export const SHOW_RESET_PASSWORD_EMAIL_BUTTON = true;
export const SHOW_INVOICING_PAGE = true;
export const ALLOW_COLLAPSE_DRAWER = true;
export const ALLOW_DEACTIVATE_MEMBER = true;
export const SHOW_MANAGEMENT_DASHBOARD = true;
export const SHOW_DELETE_CPD_ENROLLMENT_BUTTON = true;

export const SHOW_MESSAGING = true;
export const ENABLE_NOTIFICATION_TEMPLATE = true;
export const ENABLE_NOTIFICATION_UNREACHABILITY = true;
export const SHOW_CREDENTIAL_EXPIRY_FILTER_IN_NOTIFICATION = SHOW_MESSAGING;

export const SHOW_REJECT_MEMBER_BUTTON = false;
export const SHOW_DOWNLOAD_MEMBERSHIP_APPLICATION_FORM_BUTTON = true;
export const ONLINE_EMPLOYEE_DEPLOYMENT_DATE = "2025-07-18";

export const SHOW_NEW_UPLOAD_INSURANCE_BUTTON = true;
export const SHOW_NEW_UPLOAD_INSURANCE_BUTTON_V2 = true;

export const SHOW_CLINIC_ADDRESS_LINE_PREVIEW = true;
export const SHOW_QUALIFICATION_EXCEL_PREVIEW = true;
export const SHOW_REPORT_QUALIFICATION_CHECKBOX = true;

export const DOWNLOAD_CLOSE_MEMBER_LIST = true;

export const ENABLE_EXPORT_CMASA_PDF = true;

export const HIDE_COVER_AMOUNT = true;
export const ENABLE_SORT_FILES = true;

// export const MEMBER_SIGNATURE = true;
export const ENABLE_INSURANCE_DOCUMENT_SETTINGS = true;
export const ENABLE_PUBLIC_HOMEPAGE_SETTINGS = true;

export const SHOW_CREDENTIAL_EXPIRY = true;

export const ENABLE_SUMMIT = true;

export const SHOW_PAID_EVENT = true;

export const ALLOW_CHOOSE_SHOW_CANCELLED_PAYMENTS = false;

export const ALLOW_ENROLL_SUMMIT = true;

export const SHOW_EDIT_FAQ = true;

// Member custom certificate
export const ALLOW_CUSTOM_CERTIFICATE = true;

export const SHOW_NEWS_CATEGORY = true;